import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-[#0A0F1C] to-[#05050A] border-t border-cyan-500/30 py-8 md:py-12 px-4 md:px-6 shadow-[0_-4px_20px_rgba(34,211,238,0.1)]">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col items-center gap-3">
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] font-['JetBrains_Mono']">
            <a href="/agents" className="text-cyan-300 hover:text-white">Agent Commerce</a>
            <span className="text-[#334155]">·</span>
            <a href="/agent-activity" className="text-[#A855F7] hover:text-white" data-testid="footer-payments-race">
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#10B981] mr-1 animate-pulse" />
              Payments Race
            </a>
            <span className="text-[#334155]">·</span>
            <a href="/for-agents" className="text-[#94A3B8] hover:text-white">For Agents</a>
            <span className="text-[#334155]">·</span>
            <a href="/api/agent/x402/" className="text-[#94A3B8] hover:text-white">x402</a>
            <span className="text-[#334155]">·</span>
            <a href="/SKILL.md" className="text-[#94A3B8] hover:text-white">SKILL.md</a>
            <span className="text-[#334155]">·</span>
            <a href="/sitemap" className="text-[#94A3B8] hover:text-white" data-testid="footer-sitemap">Site Map</a>
          </div>
          <p className="text-[#94A3B8] text-xs">
            © {new Date().getFullYear()} ServerMemoryRFQ. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
